import React from 'react'
import clsx from 'clsx'
import {
  Typography,
  Button,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error'
import CMSText from '../Global/CMSText'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    smallText: {
      fontSize: '75%',
    },
    verticalAlign: {
      display: 'inline-flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      '&>.MuiSvgIcon-root': {
        marginRight: theme.spacing(1),
      },
    },
  })
)

type TProps = {
  datas: any
  isPack?: boolean
  layout?: undefined | boolean
  handleOpenInStoreModal: () => void
  defaultText: { title; desc; cta }
}

const InStoreSoldOut = ({
  datas,
  isPack,
  layout,
  handleOpenInStoreModal,
  defaultText,
}: TProps) => {
  const classes = useStyles()
  return (
    <>
      <Typography
        variant="h4"
        className={clsx(classes.verticalAlign, layout && classes.smallText)}
        component={'div'}
      >
        <ErrorIcon color={'error'} />
        <CMSText
          data={
            isPack
              ? datas?.data?.pack_not_available
              : datas?.data?.product_not_available
          }
          defaultText={defaultText.title}
        />
      </Typography>
      <Typography
        variant="body1"
        className={clsx(layout && classes.smallText)}
        component={'div'}
      >
        <CMSText data={datas?.data?.paragraph} defaultText={defaultText.desc} />
      </Typography>
      <Button
        variant={'contained'}
        color={'secondary'}
        onClick={handleOpenInStoreModal}
      >
        <CMSText
          asText
          data={datas?.data?.change_store_cta}
          defaultText={defaultText.cta}
        />
      </Button>
    </>
  )
}
export default InStoreSoldOut
